import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

import { AppConfigService } from 'app/services/app-config/app-config.service';
import { LANG_EN_TRANS } from '../../../translation/lang-en';
import { LANG_TH_TRANS } from '../../../translation/lang-th';
import { PatternFormat } from 'app/model/constant';

export class Form {

  private formStore: object = {};

  public formErrors = {};

  public action: string;

  public validationMessages = {};

  public get validatePattern() {
    return {
      email: /^([^<>()\[\]\\.,;:\s@"ก-๛]+(\.[^<>()\[\]\\.,;:\s@"ก-๛]+)*)@(?:(?:(?!.*[^.]{64,})(?:(?:[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*\.){1,126}){1,}(?:(?:[a-zA-Z][a-zA-Z0-9]*))(?:-[a-zA-Z0-9]+)*)|(?:\[(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){7})|(?:(?!(?:.*[a-f0-9][:\]]){7,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?)))|(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){5}:)|(?:(?!(?:.*[a-f0-9]:){5,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3}:)?)))?(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))(?:\.(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))){3}))\]))$/,
      password: PatternFormat.PASSWORD_REGEXR,
      name: `[a-zA-Z]([\\sa-zA-Z\\-]{0,97}[a-zA-Z])?`,
      fullName: /^(([A-Za-z]\.?)+)((((-([A-Za-z]\.?)+)+)|(( ([A-Za-z]\.?)+)+))*) (([A-Za-z]\.?)+)((((-([A-Za-z]\.?)+)+)|(( ([A-Za-z]\.?)+)+))*)$/,
      phone: `[0]{1}[0-9]{8,9}`,
      cardName: `[0a-zA-Z]{0,1}[\\s0a-zA-Z\\-]{0,97}[0a-zA-Z]`,
      billingName: `[a-zA-zก-ฮะ-์][a-zA-z\\-\\sก-ฮะ-์]+[a-zA-zก-ฮะ-์]`,
      billingAddress: `[a-zA-z0-9ก-ฮะ-์][a-zA-z0-9@()&,'ฯ/.\\-\\sก-ฮะ-์]+[a-zA-z0-9ก-ฮะ-์ฯ.]`,
      specialRequest: `[^ก-๛]*`,
      digit: `^(0[1-9][0-9]{7,8})$`,
    };
  }

  constructor() {

  }

  private setStore(form: FormGroup) {
    this.formStore = { ...form.getRawValue() };
  }

  clearAllErrorMessage() {
    Object.keys(this.formErrors).map(key => this.formErrors[key] = {
      valid: true,
      invalid: false,
    });
  }

  getStoreChanged(prev, current): object {
    return Object.keys(prev).concat(Object.keys(current)).reduce((map, key) => {
      if (prev[key] !== current[key]) {
        map[key] = current[key];
      }
      return map;
    }, {});
  }

  matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (form: FormGroup) => {
      const passwordInput = form.controls[passwordKey];
      const passwordConfirmationInput = form.controls[passwordConfirmationKey];

      if (passwordInput.value !== passwordConfirmationInput.value) {
        passwordConfirmationInput.setErrors({ different: false });
      }
    };
  }

  public validateInvalidCharacter = (pattern) => (control: FormControl) => {
    if (!control.value.match(pattern)) {
      return {
        invalidChar: true
      };
    }

    return null;
  }

  public clearErrorMessage(data: object) {
    const diff = { ...this.getStoreChanged(this.formStore, data) };
    Object.keys(diff).map(key => this.formErrors[key] = { valid: true, invalid: false });
    this.formStore = { ...this.formStore, ...data };
  }

  public setErrorMessage(form: FormGroup) {
    for (const field in this.formErrors) {
      if (!this.formErrors.hasOwnProperty(field)) {
        continue;
      }
      // clear previous error message (if any)
      this.formErrors[field] = {
        invalid: false,
        valid: true
      };

      const control = form.get(field);

      if (control && !control.valid) {
        // const messages = this.validationMessages[field];
        for (const key in control.errors) {
          if (!control.errors.hasOwnProperty(key)) {
            continue;
          }

          this.formErrors[field] = {
            ...this.formErrors[field],
            ...{ [key]: true, invalid: true, valid: false }
          };
        }
      }
    }

    this.setStore(form);
  }

  public setErrorMessageToControl(control: AbstractControl, field: string) {
    this.formErrors[field] = {
      invalid: false,
      valid: true
    };

    if (!control.valid) {
      for (const key in control.errors) {
        if (!control.errors.hasOwnProperty(key)) {
          continue;
        }
        this.formErrors[field] = {
          ...{ [key]: true, invalid: true, valid: false }
        };
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/form/form.ts